<script>
    import chunk from 'lodash/chunk';
    import OPTS from '../options';

    export let results = [];
    export let chunknum = 4;
    $: chunks = chunk(results, chunknum);

    const img_field = "c_did_physdesc_encodinganalog_MT_and_label_specific_extptr_href_string_multi";
    function img(doc) {
        return doc[img_field].map(it => (it.startsWith('/') ? it.substr(1) : it).replaceAll("/", ";"))[0];
    }
    function hasImage(doc) {
        return doc[img_field] && doc[img_field].length && doc[img_field][0].trim().length;
    }
</script>

{#each chunks as chunk, i (chunk)}
    <div class="card-deck">
        {#each chunk as doc (doc.id)}
            <div class="card">
                <a href="{`${OPTS.base_url}archivio/fotografico/${doc.id}?ssid=${OPTS.ssid}`}">
                    <div style="{!hasImage(doc) ? '' : `background-image: url(${OPTS.base_url}media/s/${doc.phys_archive_string}/${img(doc)})`}" class="wrap-img-percorsi-home"></div>
                    <div class="card-body">
                        <h5 class="card-title">{doc.c_did_unittitle_encodinganalog_SGLA_string || doc.c_did_unittitle_encodinganalog_SGLA_title_encodinganalog_SGLT_string}</h5>
                        <p>{doc.fund_string === 'gendel' ? 'Archivio Gendel' : 'Archivio Primoli'}</p>
                        <span><img src={`${OPTS.base_url}img/cart.svg`}></span>
                    </div>
                </a>
            </div>
        {/each}
    </div>
{/each}

<style>
    div.card {
        background-color: rgba(239, 65, 54, .8);
    }
</style>
